export default __webpack_public_path__ + "static/media/water-ok-red.f80a57d9.svg";